/*
 * Lightweight deferred loader for Google Analytics .
 * Loads only after page is idle AND (optionally) user consent is granted.
 */
(function(){
  // Pulled from config.js
  // (dynamic import avoided to keep simple synchronous execution)
  let PROD_HOST, PROD_UA, DEV_UA;
  try {
    // Attempt ES module named exports if bundler transforms
    const cfg = require('./config.js'); // eslint-disable-line global-require
    PROD_HOST = cfg.ANALYTICS_PROD_HOST;
    PROD_UA = cfg.ANALYTICS_PROD_UA;
    DEV_UA = cfg.ANALYTICS_DEV_UA;
  } catch(e) {
    // Fallback hardcoded (shouldn't normally happen)
    PROD_HOST = 'next-gen.tria.connectria.com';
    PROD_UA = 'UA-154477883-1';
    DEV_UA = 'UA-154477883-2';
  }

  function loadScript(src, {async=true, defer=true, id, attrs}={}) {
    if(id && document.getElementById(id)) return;
    const s = document.createElement('script');
    s.src = src;
    if(id) s.id = id;
    if(async) s.async = true;
    if(defer) s.defer = true;
    if(attrs) Object.entries(attrs).forEach(([k,v])=> s.setAttribute(k,v));
    document.head.appendChild(s);
    return s;
  }

  function loadGA(){
    if(window.gtag) return; // already loaded
  const ua = window.location.host.indexOf(PROD_HOST) > -1 ? PROD_UA : DEV_UA;
  loadScript(`https://www.googletagmanager.com/gtag/js?id=${ua}`, {async:true, defer:true, id:'gtag-lib'});
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);} // eslint-disable-line
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', ua, { anonymize_ip: true });
  }


  function init(){
    loadGA();
  }

  function schedule(){
    if('requestIdleCallback' in window){
      requestIdleCallback(init, {timeout:4000});
    } else {
      window.addEventListener('load', () => setTimeout(init, 1500));
    }
  }

  schedule();
})();
